module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_vm._v("Introduction: The Free Speech and Establishment Clauses")])]), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_c('p', {
    staticClass: "FirstPara"
  }, [_vm._v("The Free Speech and Establishment Clauses are presented in a single volume because, with respect to religious speech, they are inseparable. Religious speech by private citizens is constitutionally protected; religious speech by government, or sponsored by government, is constitutionally restricted and sometimes prohibited. Millions of Americans do not like one or the other of these rules, so there is lots of litigation to enforce them and lots of maneuvering to evade them.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_vm._v("Much of that litigation has come to focus on drawing the line between private and government-sponsored speech. Secularists see government sponsorship everywhere; conservative believers see it nowhere. So ")]), _c('a', {
    attrs: {
      "href": "#/009_Part01#pt-1"
    }
  }, [_vm._v("Part One")]), _vm._v(" of this volume, on freedom of religious speech, and "), _c('span', {
    attrs: {
      "href": "#/014_Chapter04a#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Section A of Part Two")]), _vm._v(", on religious speech with government sponsorship, are a package. Think of it as religious speech, with and without government sponsorship.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But the Establishment Clause addresses much more than just religious speech. In the rest of "), _c('span', {
    attrs: {
      "href": "#/013_Part02#pt-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two")]), _vm._v(", there are writings on funding of secular services provided by religious institutions, on Establishment Clause challenges to regulatory exemptions for religious practice, and on the many meanings of separation of church and state.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b6eea94","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/008_Introduction.vue
// module id = 78
// module chunks = 0